export default __webpack_public_path__ + "static/media/Live_logo.9baaea39.svg";